import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../../components/ScrollReveal";
import "./SolutionPage.css";
import { getCopy, getCopyObject } from "../../utils/copyUtils";

interface IntelligenceFeature {
  title: string;
  description: string;
}

const IntelligencePlatformPage: React.FC = () => {
  // Get copy from JSON file
  const heroData = getCopyObject<{ title: string; description: string }>("solutions.intelligence_platform.hero");
  const dashboardData = getCopyObject<{ title: string; description: string }>(
    "solutions.intelligence_platform.dashboard"
  );
  const featuresData = getCopyObject<IntelligenceFeature[]>("solutions.intelligence_platform.features");
  const ctaData = getCopyObject<{ title: string; description: string; button: string }>(
    "solutions.intelligence_platform.cta"
  );

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <ScrollReveal className="hero-content" direction="up" delay={200}>
            <h1 className="hero-title">{heroData?.title}</h1>
            <p className="hero-description">{heroData?.description}</p>
          </ScrollReveal>
        </div>
      </section>

      <main className="main">
        <div className="main__curved curved-ellipse"></div>
        <div className="main__curved-line curved-ellipse"></div>

        {/* Dashboard Section */}
        <section className="solution-section">
          <div className="solution-section-container container">
            <div className="solution-header">
              <ScrollReveal direction="up" delay={300}>
                <h2 className="solution-header__title">{dashboardData?.title}</h2>
                <p
                  className="solution-header__description"
                  dangerouslySetInnerHTML={{ __html: dashboardData?.description || "" }}
                />
              </ScrollReveal>
            </div>

            {/* <div className="dashboard-section">
              <ScrollReveal direction="up" delay={400}>
                <div className="feature-card__image-wrapper" style={{ margin: "0 auto" }}>
                  <img
                    src="/images/solutions/intelligence/dashboard.jpg"
                    alt="Intelligence Platform Dashboard"
                    title="Intelligence Platform Dashboard"
                  />
                </div>
              </ScrollReveal>
            </div> */}

            {/* Features Section */}
            <div className="solution-features">
              {featuresData &&
                featuresData.map((feature, index) => {
                  const isEven = (index + 1) % 2 === 0;
                  return (
                    <ScrollReveal
                      key={index}
                      direction={isEven ? "right" : "left"}
                      delay={300 + index * 50}
                      className="feature-card"
                    >
                      {!isEven && (
                        <div className="feature-card__image">
                          <div className="feature-card__image-wrapper">
                            <img
                              src={`/images/solutions/intelligence/silknet${index + 1}.png`}
                              alt={feature.title}
                              title={feature.title}
                            />
                          </div>
                        </div>
                      )}
                      <div className="feature-card__content">
                        <div className="feature-card__number">
                          <span className="feature-card__number-text">{index + 1}</span>
                        </div>
                        <h3 className="feature-card__title">{feature.title}</h3>
                        <p className="feature-card__description">{feature.description}</p>
                      </div>
                      {isEven && (
                        <div className="feature-card__image">
                          <div className="feature-card__image-wrapper">
                            <img
                              src={`/images/solutions/intelligence/silknet${index + 1}.png`}
                              alt={feature.title}
                              title={feature.title}
                            />
                          </div>
                        </div>
                      )}
                    </ScrollReveal>
                  );
                })}
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <ScrollReveal direction="up" delay={300}>
                <h2 className="cta-section__title">{ctaData?.title}</h2>
                <p className="cta-section__description">{ctaData?.description}</p>
                <div className="cta-section__button">
                  <Link to="/book-demo" className="btn btn-primary">
                    {ctaData?.button}
                  </Link>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default IntelligencePlatformPage;
